<div class="p-1">
  <label class="block font-medium mb-2">Material ({{ zone() }})</label>

  <select
    class="border border-stone-400 rounded p-2 w-full mb-3 bg-[#e1b574] text-black"
    [value]="selection().type ?? ''"
    (change)="setType($event)"
  >
    <option value="" disabled>Select Material</option>
    @for (type of availableTypes(); track type) {
      <option [value]="type" [selected]="type === selection().type">
        {{ type | titlecase }}
      </option>
    }
  </select>

  <label class="block font-medium mb-2">Color</label>

  <div
    class="flex flex-wrap gap-3 justify-start"
    [class.opacity-50]="!selection().type"
  >
    @for (c of availableColors(); track c.code) {
      <div
        class="color-swatch flex flex-col items-center border rounded-md p-2 cursor-pointer transition-all w-24"
        [class.selected]="c.code === selection().color"
        (click)="selectColor(c.code)"
      >
        <div class="swatch-box w-16 h-16 mb-1 border rounded flex items-center justify-center">
          <img
            src="images/swatches/{{c.code}}.png"
            alt="{{ c.name }}"
            class="max-w-full max-h-full object-contain"
          />
        </div>

        <div class="text-xs text-center truncate w-full">
          {{ c.name }}
        </div>
      </div>
    }
  </div>
</div>
